import { useMemo, useState } from "react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { GroupTourCard } from "@/components/Cards";
import { useContent } from "@/lib/content";
import { IMG } from "@/lib/site";

const TABS = ["All", "International Group Tour", "India Group Tour"];

export default function GroupTours() {
  const { groupTours, loading } = useContent();
  const [tab, setTab] = useState("All");

  const list = useMemo(() => (tab === "All" ? groupTours : groupTours.filter((t) => t.type === tab)), [groupTours, tab]);

  return (
    <div data-testid="group-tours-page">
      <SEO title="Group Tours & Fixed Departures" description="Escorted group tours with fixed departure dates — Europe, Dubai, Vietnam, Thailand and Kashmir. Tour manager, Indian meals and group savings." />
      <PageHero image={IMG.turkey} overline="Fixed Departures · Escorted Tours" title="Group Tours"
                description="Travel with like-minded explorers on our fixed-departure group tours — tour manager, planned itineraries and group savings included. Starting prices are tentative; final quotes on request." />
      <section className="py-14 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-2" data-testid="group-tour-tabs">
            {TABS.map((t) => (
              <button key={t} onClick={() => setTab(t)} data-testid={`group-tab-${t === "All" ? "all" : t.includes("International") ? "international" : "india"}`}
                      className={`rounded-full px-5 py-2.5 text-sm font-semibold transition-colors ${tab === t ? "bg-navy text-white" : "bg-white border border-slate-200 text-slate-600 hover:border-royal hover:text-royal"}`}>
                {t === "All" ? "Upcoming Group Tours" : t + "s"}
              </button>
            ))}
          </div>
          {loading ? (
            <p className="mt-10 text-slate-400">Loading group tours...</p>
          ) : list.length === 0 ? (
            <p className="mt-10 text-slate-500">No tours in this category right now — new departures are announced regularly.</p>
          ) : (
            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8">
              {list.map((t, i) => <Reveal key={t.slug} delay={(i % 2) * 0.06}><GroupTourCard tour={t} /></Reveal>)}
            </div>
          )}
          <p className="mt-8 text-xs text-slate-400">Group tour costing is shared on request and depends on departure date, group size and hotel category.</p>
        </div>
      </section>
    </div>
  );
}
